var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 90,
    viewBox: "0 0 120 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4219 50.1562C28.8281 51.5625 31.4062 51.5625 32.8125 50.1562L45 37.9688L64.6875 57.8906C66.0938 59.2969 68.6719 59.2969 70.0781 57.8906L95.8594 32.1094L102.891 38.9062C106.406 42.6562 112.5 40.0781 112.5 34.9219V11.25C112.5 9.375 110.625 7.5 108.75 7.5H85.0781C79.9219 7.5 77.3438 13.5938 81.0938 17.1094L87.8906 24.1406L67.5 44.7656L47.5781 24.8438C46.1719 23.4375 43.5938 23.4375 42.1875 24.8438L24.8438 42.1875C23.4375 43.5938 23.4375 46.1719 24.8438 47.5781L27.4219 50.1562ZM116.25 78.75H11.25V3.75C11.25 1.875 9.375 0 7.5 0H3.75C1.64062 0 0 1.875 0 3.75V82.5C0 86.7188 3.28125 90 7.5 90H116.25C118.125 90 120 88.3594 120 86.25V82.5C120 80.625 118.125 78.75 116.25 78.75Z",
    fill: "#516393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInactive);
export default __webpack_public_path__ + "static/media/dashboard-inactive.939e930c33c809c889786ecc1d2acc9c.svg";
export { ForwardRef as ReactComponent };